import { Input, Label, ReadOnlyText, RedText } from "./styles";

export default function QuestionOptionalCheckbox({
  readOnly = false,
  checked = false,
  onChangeChecked = () => null,
}) {

  if(readOnly) {
    return (
      <ReadOnlyText>
        {checked ? <RedText>*{" "}</RedText> : ''}
        {checked ? 'Questão Obrigatória' : 'Questão Opcional'}
      </ReadOnlyText>
    )
  }

  return (
    <Label>
      <Input type="checkbox" checked={checked} onChange={e => onChangeChecked(!e.target.checked)} />
      <span>Questão Obrigatória</span>
    </Label>
  );
}
